import { Button, Col, Modal, Row, Steps, Spin } from "antd";
import { useState } from "react";
import CSVUpload from "./CSVUpload";
import csvImport from "../../assets/svg/csv-import.svg";
import mapping from "../../assets/svg/mapping.svg";
import Mapping from "./Mapping";

const CSVImport = ({ open, handleCancel, handleCSVImport }) => {
  const [csvImportPayload, setCsvImportPayload] = useState();
  const [error, setError] = useState();

  return (
    <Modal
      title={null}
      open={open}
      onCancel={() => {
        handleCancel();
        setCsvImportPayload();
        setError();
      }}
      okText="Confirm"
      cancelText="Cancel"
      className="delete-popup"
      centered
      width={700}
      footer={<></>}
    >
      <div className="tw-bg-secondary-color tw-text-text-primary tw-text-lg tw-font-semibold tw-py-4 tw-px-6 tw-rounded-t-2xl">
        Import Leads via CSV
        <div className="tw-text-xs tw-text-sub-text tw-font-normal tw-mt-1">
          Upload your CSV file. AI will automatically map fields and detect
          duplicates.
        </div>
      </div>
      <VerticalStepper
        error={error}
        setError={setError}
        csvImportPayload={csvImportPayload}
        setCsvImportPayload={setCsvImportPayload}
        handleCSVImport={handleCSVImport}
        handleCancel={handleCancel}
      />
    </Modal>
  );
};

export default CSVImport;

export const VerticalStepper = ({
  csvImportPayload,
  setCsvImportPayload,
  handleCancel,
  handleCSVImport,
  error,
  setError,
}) => {
  const [current, setCurrent] = useState(0);
  const [isCooking, setIsCooking] = useState(false);

  const steps = [
    {
      title: (
        <div className="tw-text-sm tw-font-semibold tw-mt-1">Upload CSV</div>
      ),
      content: (
        <CSVUpload
          csvImportPayload={csvImportPayload}
          setError={setError}
          setCsvImportPayload={setCsvImportPayload}
        />
      ),
      icon: (
        <div
          className={`tw-rounded-full tw-flex tw-items-center tw-justify-center tw-p-2 tw-size-[30px] tw-text-sm tw-font-semibold ${current <= 1 ? "tw-text-white tw-bg-text-primary" : "tw-text-text-primary tw-border tw-border-solid tw-border-border-secondary"}`}
        >
          1
        </div>
      ),
    },
    {
      title: (
        <div className="tw-text-sm tw-font-semibold tw-mt-1">Map Fields</div>
      ),
      content: (
        <Mapping
          csvImportPayload={csvImportPayload}
          setCsvImportPayload={setCsvImportPayload}
          setError={setError}
        />
      ),
      icon: (
        <div
          className={`tw-rounded-full tw-flex tw-items-center tw-justify-center tw-p-2 tw-size-[30px] tw-text-sm tw-font-semibold ${current === 1 ? "tw-text-white tw-bg-text-primary" : "tw-text-text-primary tw-border tw-border-solid tw-border-border-secondary"}`}
        >
          2
        </div>
      ),
    },
  ];

  const next = () => {
    if (csvImportPayload?.file) {
      setCurrent((prev) => prev + 1);
    } else {
      setError("File upload required.");
    }
  };
  const prev = () => setCurrent((prev) => prev - 1);

  const finish = async () => {
    if (error) return;
    setIsCooking(true);
    try {
      await handleCSVImport(csvImportPayload, () => {
        setCurrent(0);
        handleCancel();
        setCsvImportPayload();
        setError();
      });
    } finally {
      setIsCooking(false);
    }
  };

  return (
    <Spin spinning={isCooking}>
      <div className="tw-mx-5 tw-my-10">
        <Steps
          // direction="vertical"
          current={current}
          items={steps.map((step) => ({
            title: step.title,
            icon: step.icon,
          }))}
          style={{
            maxWidth: 400,
            margin: "0 auto",
          }}
        />
        <div>{steps[current].content}</div>
        <div className="text-error mt10">{error}</div>
      </div>

      <div
        className={`d-flex ${current < steps.length - 1 ? "tw-justify-end" : "tw-justify-between"} gap-20 tw-p-6 tw-border-t tw-border-solid tw-border-border-secondary tw-border-b-0 tw-border-r-0 tw-border-l-0`}
      >
        {current > 0 && (
          <Button
            type="text"
            className="tw-text-sm tw-font-semibold"
            onClick={prev}
          >
            ← Back
          </Button>
        )}
        {current < steps.length - 1 && (
          <Button
            className="!tw-bg-white tw-px-4 !tw-text-text-primary tw-shadow-none !tw-text-xs !tw-font-semibold tw-border tw-border-solid tw-border-border-secondary tw-rounded-[10px]"
            type="primary"
            onClick={next}
          >
            Continue →
          </Button>
        )}
        {current === steps.length - 1 && (
          <Button className="theme-btn" type="primary" onClick={finish} disabled={!!error} loading={isCooking}>
            Import
          </Button>
        )}
      </div>
    </Spin>
  );
};
